{
  "ticket": {
    "title": "Support Tickets",
    "subtitle": "Customer support queue",
    "columns": {
      "id": "Ticket ID",
      "subject": "Subject",
      "merchant": "Merchant",
      "assignee": "Assignee",
      "priority": "Priority",
      "status": "Status",
      "category": "Category",
      "createdAt": "Created",
      "updatedAt": "Updated",
      "sla": "SLA"
    },
    "actions": {
      "create": "New Ticket",
      "assign": "Assign",
      "reassign": "Reassign",
      "close": "Close",
      "reopen": "Reopen",
      "reply": "Reply",
      "addNote": "Add Internal Note",
      "escalate": "Escalate"
    },
    "filters": {
      "status": "Status",
      "priority": "Priority",
      "category": "Category",
      "assignee": "Assignee",
      "overdue": "Overdue Only",
      "search": "Search tickets"
    },
    "empty": {
      "title": "No tickets",
      "body": "There are no tickets matching your filters."
    },
    "errors": {
      "loadFailed": "Failed to load tickets",
      "assignFailed": "Failed to assign ticket"
    },
    "detail": {
      "conversation": "Conversation",
      "history": "History",
      "attachments": "Attachments",
      "relatedOrders": "Related Orders",
      "merchantInfo": "Merchant Info"
    }
  },
  "ticket_status": {
    "open": "Open",
    "inProgress": "In Progress",
    "waitingCustomer": "Waiting on Customer",
    "waitingVendor": "Waiting on Vendor",
    "resolved": "Resolved",
    "closed": "Closed"
  },
  "ticket_priority": {
    "low": "Low",
    "normal": "Normal",
    "high": "High",
    "urgent": "Urgent"
  },
  "ticket_category": {
    "order": "Order Issue",
    "shipping": "Shipping",
    "payment": "Payment",
    "product": "Product Quality",
    "account": "Account",
    "technical": "Technical",
    "other": "Other"
  },
  "sla": {
    "label": "SLA",
    "withinSla": "Within SLA",
    "approachingSla": "Approaching SLA breach",
    "breached": "SLA Breached",
    "timeRemaining": "Time remaining: {{time}}",
    "timeOverdue": "Overdue by: {{time}}"
  },
  "dashboard": {
    "title": "Support Dashboard",
    "subtitle": "KPIs and agent performance",
    "kpis": {
      "openTickets": "Open Tickets",
      "avgResponseTime": "Avg Response Time",
      "avgResolutionTime": "Avg Resolution Time",
      "slaCompliance": "SLA Compliance",
      "slaBreaches": "SLA Breaches (24h)",
      "satisfaction": "CSAT Score"
    },
    "charts": {
      "ticketsOverTime": "Tickets Over Time",
      "categoryBreakdown": "Category Breakdown",
      "priorityBreakdown": "Priority Breakdown",
      "agentLoad": "Agent Load"
    },
    "agentTable": {
      "title": "Agent Performance",
      "columns": {
        "agent": "Agent",
        "active": "Active",
        "resolved24h": "Resolved (24h)",
        "avgResponse": "Avg Response",
        "csat": "CSAT"
      }
    },
    "filters": {
      "dateRange": "Date Range",
      "team": "Team"
    }
  },
  "statusLabels": {
    "Open": "Open",
    "InProgress": "In Progress",
    "In Progress": "In Progress",
    "AwaitingHandler": "Awaiting handler",
    "PendingSupportReview": "Pending support review",
    "Resolved": "Resolved",
    "Closed": "Closed",
    "Reopened": "Reopened"
  },
  "originLabels": {
    "merchant": "Merchant-opened",
    "vendor": "Vendor-opened",
    "admin": "Admin-opened"
  },
  "deptQueue": {
    "title": "Department dispatch queue",
    "loading": "Loading…",
    "empty": "No dispatches for this department.",
    "colTicket": "Parent ticket",
    "colStatus": "Status",
    "colScopeNote": "Scope note",
    "colCreatedAt": "Created",
    "openTicket": "Open ticket"
  },
  "priorityLabels": {
    "Critical": "Critical",
    "High": "High",
    "Medium": "Medium",
    "Low": "Low"
  },
  "categoryLabels": {
    "Order": "Order",
    "Billing": "Billing",
    "Product": "Product",
    "Account": "Account",
    "General": "General"
  },
  "bugStatusLabels": {
    "open": "Open",
    "in_progress": "In Progress",
    "resolved": "Resolved",
    "closed": "Closed"
  },
  "bugPriorityLabels": {
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical"
  },
  "ticketsPage": {
    "heading": "Support Tickets",
    "subtitle": "Ticket queue by SLA, priority and category.",
    "totalCount": "{{total}} tickets",
    "forbidden": "You do not have permission to view support tickets.",
    "loadError": "Failed to load the ticket list.",
    "tablistAria": "Ticket status",
    "tableAria": "Support ticket list",
    "tabs": {
      "all": "All",
      "open": "Open",
      "inProgress": "In Progress",
      "resolved": "Resolved",
      "closed": "Closed",
      "reopened": "Reopened"
    },
    "columns": {
      "id": "ID",
      "subject": "Subject",
      "merchant": "Merchant",
      "priority": "Priority",
      "status": "Status",
      "sla": "SLA",
      "assignee": "Assignee",
      "createdAt": "Created"
    },
    "loading": "Loading…",
    "empty": "No tickets match the current filters.",
    "rows": "Rows",
    "rowsPerPageAria": "Rows per page",
    "merchantFallback": "Merchant {{id}}",
    "unassigned": "Unassigned"
  },
  "ticketDetail": {
    "missingId": "Missing ticket ID in the URL.",
    "backToList": "Back to list",
    "back": "Tickets",
    "loadError": "Could not load ticket details: {{message}}",
    "unknownError": "Unknown error.",
    "updateSuccess": "Ticket updated",
    "updateFailTitle": "Update failed",
    "escalatedBadge": "Escalated · Level {{level}}",
    "escalateBtn": "Escalate",
    "createdAt": "Created {{time}}",
    "requesterLabel": "Requester:",
    "firstResponseLabel": "First response:",
    "resolutionLabel": "Resolution:",
    "categoryLabel": "Category:",
    "description": "Description",
    "attachments": "Attachments",
    "transitions": {
      "start": "Start working",
      "markResolved": "Mark as resolved",
      "close": "Close ticket",
      "reopen": "Reopen"
    }
  },
  "slaWarning": {
    "aria": "SLA warning",
    "firstResponseTitle": "SLA: Response overdue",
    "resolutionTitle": "SLA: Resolution overdue",
    "respondBy": "Respond by: {{time}}",
    "resolveBy": "Resolve by: {{time}}",
    "firstResponseAction": "Response overdue — Immediate action required",
    "resolutionAction": "Resolution overdue — Immediate action required"
  },
  "supportDashboard": {
    "forbiddenTitle": "Access denied",
    "forbiddenBody": "Your account does not have permission to view Support reports.",
    "heading": "Support Dashboard",
    "kpiAria": "Support KPIs",
    "chartsAria": "Support charts",
    "kpi": {
      "open": "Open tickets",
      "overdue": "Overdue",
      "avgResponse": "Avg first response",
      "resolvedToday": "Resolved today"
    },
    "slaChartTitle": "SLA compliance per priority",
    "volumeChartTitle": "Volume by category",
    "agentSectionTitle": "Agent performance",
    "empty": "No tickets yet.",
    "error": "Could not load Support data — retrying."
  },
  "conversation": {
    "sectionAria": "Ticket conversation",
    "tablistAria": "Message type",
    "tabs": {
      "public": "Merchant",
      "internal": "Internal Notes"
    },
    "internalBadge": "Internal",
    "internalBanner": "Internal notes do not count toward SLA and are not sent to the customer.",
    "emptyPublic": "No public messages yet.",
    "emptyInternal": "No internal notes yet.",
    "dispatchButton": "Dispatch"
  },
  "replyBox": {
    "sectionAria": "Reply composer",
    "heading": "Reply",
    "typeLabel": "Type",
    "type": {
      "public": "Public (sent to customer)",
      "internal": "Internal (admins only)"
    },
    "placeholderPublic": "Write a reply to the customer.",
    "placeholderInternal": "Internal note — the customer cannot see this.",
    "removeAttachment": "Remove {{filename}}",
    "uploading": "Uploading...",
    "attach": "Attach file",
    "sending": "Sending...",
    "send": "Send",
    "uploadFailTitle": "Could not upload attachment",
    "emptyContentTitle": "No content",
    "emptyContentBody": "Please enter content before sending.",
    "sentNoteTitle": "Internal note added",
    "sentReplyTitle": "Reply sent",
    "sendFailTitle": "Could not send",
    "unknownError": "Unknown error.",
    "internalToggle": "Internal note (support only)"
  },
  "infoSidebar": {
    "aside": "Ticket info",
    "statusSection": "Status",
    "statusLabel": "Status",
    "priorityLabel": "Priority",
    "assigneeLabel": "Assignee",
    "escalated": "Escalated to level {{level}}",
    "relatedOrders": "Related orders",
    "noRelatedOrders": "No orders linked yet.",
    "activity": "Activity",
    "noActivity": "No activity recorded yet.",
    "system": "System"
  },
  "assigneePicker": {
    "unassigned": "— Unassigned —",
    "searchPlaceholder": "Search by name or email…",
    "noMatch": "No admin found matching \"{{query}}\"."
  },
  "slaBadge": {
    "overdue": "Overdue",
    "now": "now",
    "closed": "Closed",
    "closedAria": "Ticket closed",
    "unknown": "SLA unknown",
    "leftDaysHours": "{{days}}d {{hours}}h left",
    "leftDays": "{{days}}d left",
    "leftHoursMins": "{{hours}}h {{mins}}m left",
    "leftHours": "{{hours}}h left",
    "leftMins": "{{mins}}m left",
    "ariaOverdue": "SLA overdue by {{mins}} minutes",
    "ariaRemaining": "SLA {{copy}}"
  },
  "listFilters": {
    "regionAria": "Support ticket list filters",
    "priorityLabel": "Priority",
    "priorityAria": "Filter by priority",
    "categoryLabel": "Category",
    "categoryAria": "Filter by category",
    "assigneeLabel": "Assignee",
    "assigneeAria": "Filter by assignee",
    "all": "All",
    "assigneeAll": "Assignee (all)",
    "unassigned": "Unassigned",
    "overdue": "Overdue",
    "searchPlaceholder": "Search by ID or subject…",
    "searchAria": "Search tickets by ID or subject"
  },
  "escalate": {
    "title": "Escalate ticket",
    "modeLegend": "How to pick the admin",
    "modeRoundRobin": "Round-robin (auto-assign on-call admin)",
    "modePick": "Pick a specific admin",
    "pickLabel": "Receiving admin",
    "pickPlaceholder": "— Select admin —",
    "slaLabel": "New SLA (hours)",
    "slaHint": "Default {{hours}} hours.",
    "noteLabel": "Note",
    "notePlaceholder": "Reason for escalation (written to the audit log).",
    "cancel": "Cancel",
    "confirm": "Confirm escalation",
    "sending": "Sending...",
    "noAdminTitle": "No admin selected",
    "noAdminBody": "Please select an admin to escalate to.",
    "noNoteTitle": "Missing reason",
    "noNoteBody": "Please enter a note for the escalation.",
    "invalidSlaTitle": "Invalid SLA",
    "invalidSlaBody": "SLA must be a positive number of hours.",
    "successTitle": "Ticket escalated",
    "failTitle": "Could not escalate",
    "unknownError": "Unknown error."
  },
  "agentTable": {
    "empty": "No agent has handled tickets yet.",
    "columns": {
      "agent": "Agent",
      "open": "Open",
      "avgResponse": "Avg first response",
      "resolutionRate": "Resolution rate"
    }
  },
  "charts": {
    "sla": {
      "empty": "No tickets to score for SLA yet.",
      "aria": "SLA compliance per priority",
      "met": "Met",
      "missed": "Missed"
    },
    "volume": {
      "empty": "No tickets to categorize yet.",
      "aria": "Ticket volume by category"
    }
  },
  "bugTracker": {
    "title": "Bug Tracker",
    "forbiddenBody": "You do not have permission to access the Bug Tracker. This page is for Super Admin only.",
    "saLock": "Super Admin only",
    "subtitle": "Manage bug reports — drag and drop a card to another column to change its status. All runtime errors from the admin SPA are automatically pushed here (auto-reported).",
    "autoBannerText": "auto-reported errors in the last 7 days. Enable the \"Auto-reported only\" filter to view them separately.",
    "viewToggleAria": "View toggle",
    "viewKanban": "Kanban",
    "viewTable": "Table",
    "severity": "Severity",
    "all": "All",
    "autoOnly": "Auto-reported only",
    "search": "Search",
    "searchPlaceholder": "title or description...",
    "refresh": "Refresh",
    "loading": "Loading bug reports…",
    "loadError": "Could not load bug reports.",
    "table": {
      "empty": "No bug reports match the filter.",
      "title": "Title",
      "status": "Status",
      "priority": "Priority",
      "category": "Category",
      "reporter": "Reporter",
      "assignee": "Assignee",
      "created": "Created",
      "occurrences": "Count"
    },
    "modal": {
      "close": "Close",
      "id": "ID:",
      "created": "Created:",
      "seen": "Seen: {{count}}x",
      "auto": "auto",
      "statusLabel": "Status",
      "assigneeLabel": "Assignee (user_id)",
      "assigneePlaceholder": "ObjectId or leave blank",
      "save": "Save",
      "linked": "Linked",
      "merchant": "Merchant:",
      "vendor": "Vendor:",
      "order": "Order:",
      "sourceUrl": "Source URL:",
      "description": "Description",
      "noDescription": "(no description)",
      "stackTrace": "Stack trace",
      "screenshots": "Screenshots ({{count}})",
      "comments": "Comments ({{count}})",
      "noComments": "No comments yet."
    },
    "create": {
      "button": "New bug",
      "heading": "Create bug report",
      "titleLabel": "Title",
      "titlePlaceholder": "Short summary of the problem",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "What happened, where, and how to reproduce it",
      "categoryLabel": "Category",
      "priorityLabel": "Priority",
      "assigneeLabel": "Assignee",
      "assigneePlaceholder": "ObjectId or leave blank",
      "submit": "Create",
      "submitting": "Creating…",
      "cancel": "Cancel",
      "titleRequired": "Title is required (at least 2 characters).",
      "createError": "Could not create the bug report.",
      "manualHint": "Manually created reports are not marked auto-reported.",
      "assigneeUnassigned": "Unassigned",
      "assigneeSearchPlaceholder": "Search admin by name or email…",
      "assigneeSearching": "Searching…",
      "assigneeNoResults": "No matching admin"
    }
  },
  "kanban": {
    "regionAria": "Bug Tracker Kanban board",
    "columnAria": "{{label}} column",
    "empty": "No bugs in this status",
    "cardAria": "Bug: {{title}} ({{priority}})",
    "unassigned": "unassigned",
    "reporterTitle": "Reporter: {{name}}",
    "assigneeTitle": "Assignee: {{name}}",
    "screenshotsAria": "{{count}} screenshots"
  },
  "listV2": {
    "refresh": "Refresh",
    "newTicket": "New Ticket",
    "searchPlaceholder": "Search by ticket #, title, or email...",
    "allStatuses": "All Statuses",
    "allCategories": "All Categories",
    "allChannels": "All Channels",
    "allPriorities": "All Priorities",
    "allTypes": "All Types",
    "allAssignees": "All Assignees",
    "typeInternal": "Internal",
    "typeMerchant": "Merchant",
    "showingCount": "Showing {{shown}} of {{total}} tickets",
    "showingRecords": "Showing {{from}}-{{to}} of {{total}} records",
    "selectAll": "Select all",
    "selectRow": "Select row",
    "viewDetail": "View detail",
    "moreActions": "More actions",
    "stats": {
      "open": "Open",
      "urgent": "Urgent",
      "overdueSla": "Overdue SLA",
      "resolvedToday": "Resolved Today"
    },
    "columns": {
      "ticket": "Ticket #",
      "type": "Type",
      "category": "Category",
      "assigned": "Assigned",
      "lastUpdated": "Last Updated",
      "actions": "Actions"
    },
    "quickFilters": {
      "heading": "Quick filters"
    },
    "assignSuccess": "Ticket assigned",
    "unassign": "Unassign",
    "bulk": {
      "selectedCount": "{{count}} selected",
      "assign": "Assign to…",
      "setStatus": "Set status…",
      "setPriority": "Set priority…",
      "markRead": "Mark read",
      "clear": "Clear selection",
      "done": "{{ok}} updated",
      "failed": "{{fail}} failed",
      "skipped": "{{skipped}} skipped (invalid transition)"
    }
  },
  "newTicket": {
    "title": "New Ticket",
    "subject": "Subject",
    "description": "Description",
    "merchant": "Merchant",
    "merchantPlaceholder": "Search merchant by name or email...",
    "merchantLoading": "Searching...",
    "merchantEmpty": "No merchant matched.",
    "category": "Category",
    "priority": "Priority",
    "type": "Ticket Type",
    "cancel": "Cancel",
    "create": "Create",
    "creating": "Creating...",
    "created": "Ticket created.",
    "createFailed": "Could not create the ticket."
  },
  "detailV2": {
    "backToTickets": "Back to Tickets",
    "notFound": "Ticket not found.",
    "issueDescription": "Issue Description",
    "conversation": "Conversation ({{count}} messages)",
    "noMessages": "No messages yet.",
    "internalNote": "Internal note",
    "internalNoteHint": "Internal note (only visible to staff)",
    "replyPlaceholder": "Type your message...",
    "sendReply": "Send Reply",
    "sendFailed": "Could not send the message.",
    "ticketStatus": "Ticket Status",
    "assign": "Assign",
    "escalate": "Escalate",
    "escalatedBadge": "Escalated · Level {{level}}",
    "merchantInformation": "Merchant Information",
    "merchantOrders": "{{count}} orders",
    "merchantLifetime": "{{amount}} lifetime",
    "resolution": "Resolution",
    "resolutionType": "Resolution Type",
    "resolutionNotes": "Resolution Notes",
    "resolve": "Resolve",
    "ratingTitle": "Merchant Rating",
    "activityLog": "Activity Log",
    "noActivity": "No activity yet.",
    "createdAt": "Created At",
    "updatedAt": "Updated",
    "resolvedAt": "Resolved",
    "updated": "Ticket updated.",
    "updateFailed": "Could not update the ticket.",
    "vendorThread": "Vendor thread — {{vendor}}",
    "vendorThreadHint": "Not visible to the merchant",
    "vendorFallback": "Vendor",
    "vendorReplyPlaceholder": "Message the vendor...",
    "vendorStatusLabels": {
      "Pending": "Vendor: Pending",
      "InProgress": "Vendor: In Progress",
      "Done": "Vendor: Done"
    },
    "relatedOrders": "Related Orders",
    "noRelatedOrders": "No related orders",
    "linkOrderSearch": "Search orders by number…",
    "linkOrderLink": "Link",
    "linkOrderUnlink": "Unlink",
    "linkOrderLinked": "Linked orders",
    "linkOrderEmpty": "No orders found",
    "resolveNeedsOrder": "Link the related order before resolving with this action.",
    "activity": {
      "escalated": "Escalated",
      "dispatched": "Dispatched to vendor",
      "pushedToVendor": "Pushed to vendor",
      "dispatchCancelled": "Dispatch cancelled",
      "dispatchReturned": "Dispatch returned",
      "relatedOrdersSet": "Orders linked",
      "merchantConfirmedClose": "Merchant confirmed close",
      "vendorClosed": "Vendor closed",
      "merchantReopened": "Merchant reopened",
      "unassignedFallback": "Auto-unassigned",
      "updated": "Updated"
    },
    "permissionDenied": "You do not have permission to perform this action.",
    "readByMerchant": "Read by merchant",
    "sentAwaitingRead": "Sent — not read yet",
    "pushToVendor": "Push to Vendor",
    "pushToDepartment": "Push to Department",
    "activityFields": {
      "assignee": "Assignee",
      "status": "Status",
      "priority": "Priority",
      "category": "Category"
    }
  },
  "pushVendor": {
    "cta": "Push to Vendor",
    "repush": "Vendor pushed",
    "title": "Push ticket to a vendor",
    "description": "The vendor gets the ticket info and a separate vendor thread. They never see the merchant conversation.",
    "vendor": "Vendor",
    "vendorPlaceholder": "Select a vendor...",
    "note": "Handoff note",
    "notePlaceholder": "Context for the vendor (lands in the vendor thread)...",
    "confirm": "Push",
    "pushing": "Pushing...",
    "pushed": "Ticket pushed to vendor.",
    "failed": "Could not push the ticket."
  },
  "resolutionLabels": {
    "Reprint": "Reprint",
    "FullRefund": "Full Refund",
    "PartialRefund": "Partial Refund",
    "StoreCredit": "Store Credit",
    "Replacement": "Replacement",
    "ShippingCredit": "Shipping Credit",
    "NoActionRequired": "No Action Required",
    "Escalated": "Escalated"
  },
  "inboxV2": {
    "title": "Inbox",
    "chipAll": "All",
    "chipOpen": "Open",
    "chipAssignedToMe": "Assigned to me",
    "searchPlaceholder": "Search conversations...",
    "empty": "No conversations.",
    "selectPrompt": "Select a conversation to start chatting",
    "openTicket": "Open ticket →",
    "unreadDot": "Unread"
  },
  "performanceV2": {
    "heading": "Support Performance",
    "subtitle": "Analyze agent performance and merchant satisfaction",
    "startDate": "Start Date",
    "endDate": "End Date",
    "category": "Category",
    "agent": "Agent",
    "rating": "Rating",
    "allAgents": "All Agents",
    "allRatings": "All Ratings",
    "reset": "Reset",
    "totalRated": "Total Rated",
    "averageRating": "Average Rating",
    "satisfactionRate": "Satisfaction Rate",
    "satisfactionSub": "4-5 stars",
    "avgResponseTime": "Avg Response Time",
    "leaderboard": "Agent Leaderboard",
    "rank": "Rank",
    "agentCol": "Agent",
    "ticketsHandled": "Tickets Handled",
    "ratingCol": "Rating",
    "responseTime": "Response Time",
    "slaBreach": "SLA Breach",
    "noData": "No performance data available",
    "ratingDistribution": "Rating Distribution",
    "categoryBreakdown": "Category Breakdown",
    "categoryCol": "Category"
  },
  "configV2": {
    "heading": "Support Configurations",
    "subtitle": "Manage channels and agent settings",
    "tabChannels": "Channels",
    "tabAgents": "Agents",
    "totalConnections": "Total connections",
    "searchChannels": "Search channels...",
    "addChannel": "Add Channel",
    "saveChannel": "Save",
    "colName": "Name",
    "colType": "Type",
    "colUpdated": "Last Updated",
    "colActive": "Active",
    "noChannels": "No channels configured yet. Add your first channel to get started.",
    "channelCreated": "Channel added.",
    "channelDeleted": "Channel deleted.",
    "deleteChannel": "Delete channel",
    "actionFailed": "Action failed.",
    "channelTypes": {
      "webchat": "Webchat",
      "email": "Email",
      "ai_bot": "AI Bot",
      "staff": "Staff"
    },
    "colAgent": "Agent",
    "colEmail": "Email",
    "colRole": "Role",
    "noAgents": "No support agents found.",
    "colStatus": "Status",
    "colCategories": "Categories",
    "colLoad": "Load",
    "colWorkingHours": "Working hours",
    "addAgent": "Add Agent",
    "configure": "Configure",
    "removeAgent": "Remove agent",
    "searchAgents": "Search agents by name…",
    "availableAll": "All availability",
    "categoryAll": "All categories",
    "totalAgents": "Total agents",
    "agentLoadError": "Could not load the agent roster.",
    "unassignedQueue": "Unassigned queue",
    "unassignedTickets": "{{count}} unassigned ticket(s) awaiting assignment",
    "agentStatus": {
      "available": "Available",
      "unavailable": "Unavailable",
      "atCap": "At capacity",
      "outOfHours": "Out of hours"
    },
    "pairBridge": "Pair a Facebook (Personal) bridge",
    "pairBridgeSubtitle": "Create a bridge channel and issue a one-time device token for a headless runner.",
    "deviceToken": "Device token",
    "deviceTokenHint": "Copy this token now — it is shown only once.",
    "copyToken": "Copy token",
    "tokenCopied": "Token copied",
    "revokeDevice": "Revoke",
    "revokeConfirm": "Revoke this device? Its token stops working immediately.",
    "devicesTitle": "Paired devices",
    "colDeviceStatus": "Device status",
    "pairSuccess": "Bridge paired. Copy the token now.",
    "pairFailed": "Pairing failed.",
    "agentUserIdLabel": "Agent user ID",
    "channelNameLabel": "Channel name",
    "colMaxConcurrent": "Max"
  },
  "agentConfig": {
    "title": "Configure agent — {{name}}",
    "available": "Available",
    "availableHint": "Agent receives new ticket assignments",
    "workingHours": "Working hours",
    "timezone": "Timezone",
    "timezonePlaceholder": "e.g. Asia/Ho_Chi_Minh",
    "windowsEmpty": "No windows — available at any time.",
    "addWindow": "Add window",
    "removeWindow": "Remove window",
    "day": "Day",
    "startTime": "Start",
    "endTime": "End",
    "days": {
      "sun": "Sunday",
      "mon": "Monday",
      "tue": "Tuesday",
      "wed": "Wednesday",
      "thu": "Thursday",
      "fri": "Friday",
      "sat": "Saturday"
    },
    "categories": "Categories",
    "categoriesHint": "Leave all unselected to handle every category.",
    "maxConcurrent": "Max concurrent tickets",
    "maxConcurrentHint": "Leave empty for unlimited.",
    "maxConcurrentPlaceholder": "Unlimited",
    "channels": "Channels",
    "channelsHint": "Ticket sources this agent handles.",
    "channelsEmpty": "No channels configured yet.",
    "notifyChannels": "Notification channels",
    "notifyInApp": "In-app",
    "notifyInAppHint": "Always on",
    "notifyTargetPlaceholder": "Chat ID or webhook target",
    "notify": {
      "telegram": "Telegram",
      "lark": "Lark"
    },
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "saved": "Configuration saved.",
    "saveFailed": "Could not save agent configuration."
  },
  "addAgent": {
    "title": "Add support agent",
    "subtitle": "Pick an internal staff member to add to the support roster.",
    "pickerLabel": "Staff member",
    "searchPlaceholder": "Search by name or email…",
    "loading": "Loading staff…",
    "noStaff": "No internal staff available.",
    "noMatch": "No staff matched \"{{query}}\".",
    "loadError": "Could not load the staff list.",
    "submit": "Add agent",
    "submitting": "Adding…",
    "cancel": "Cancel",
    "added": "Agent added.",
    "addFailed": "Could not add the agent."
  },
  "removeAgent": {
    "title": "Remove agent — {{name}}",
    "body": "The agent will be deactivated and removed from the support roster. Their account role is not changed.",
    "openTicketsCount": "{{count}} open ticket(s) will be force-reassigned to other available agents before removal.",
    "noOpenTickets": "This agent has no open tickets — nothing to reassign.",
    "confirm": "Remove agent",
    "removing": "Removing…",
    "cancel": "Cancel",
    "removed": "Agent removed.",
    "removedWithReassign": "Agent removed. {{count}} ticket(s) force-reassigned.",
    "removeFailed": "Could not remove the agent.",
    "notFound": "This agent no longer exists. The roster has been refreshed."
  },
  "realtime": {
    "newTicketTitle": "New support ticket",
    "newTicketBody": "A new ticket needs attention.",
    "tabFlash": "New ticket",
    "markRead": "Mark as read",
    "markAllRead": "Mark all read",
    "replyTitle": "New reply",
    "replyBody": "A customer replied to a ticket."
  },
  "routingRules": {
    "title": "Routing rules",
    "subtitle": "Auto-assign incoming tickets by category, channel or SLA. Rules apply in order.",
    "add": "Add routing rule",
    "empty": "No routing rules yet. Add one to auto-route incoming tickets.",
    "loading": "Loading routing rules…",
    "loadError": "Could not load routing rules.",
    "edit": "Edit",
    "delete": "Delete",
    "createTitle": "New routing rule",
    "editTitle": "Edit routing rule",
    "typeLabel": "Condition type",
    "matchLabel": "Match value",
    "matchPlaceholder": "e.g. Billing, webchat, or an SLA tier",
    "targetKindLabel": "Target",
    "agentsLabel": "Assign to agents",
    "agentsHint": "Matching tickets are routed to the selected agents.",
    "agentsEmpty": "No support agents in the roster yet.",
    "escalateHint": "Matching tickets are escalated to the on-call pool.",
    "orderLabel": "Order",
    "orderHint": "Lower numbers are evaluated first.",
    "save": "Save rule",
    "saving": "Saving…",
    "cancel": "Cancel",
    "created": "Routing rule created.",
    "updated": "Routing rule updated.",
    "deleted": "Routing rule deleted.",
    "saveFailed": "Could not save the routing rule.",
    "deleteFailed": "Could not delete the routing rule.",
    "matchRequired": "Enter a match value.",
    "agentsRequired": "Select at least one agent.",
    "targetAgentsSummary": "Assign to {{count}} agent(s)",
    "targetEscalateSummary": "Escalate to on-call",
    "typeAll": "All types",
    "typeFilterAria": "Filter by condition type",
    "sortAria": "Sort rules by",
    "sortOrder": "Order",
    "sortCreated": "Created",
    "dirAsc": "Ascending",
    "dirDesc": "Descending",
    "deleteConfirmTitle": "Delete routing rule?",
    "deleteConfirmBody": "This rule will be removed and matching tickets will no longer be auto-routed by it.",
    "deleting": "Deleting…"
  },
  "routingType": {
    "category": "Category",
    "channel": "Channel",
    "sla": "SLA"
  },
  "routingTarget": {
    "agents": "Assign to agents",
    "escalate": "Escalate"
  },
  "availability": {
    "available": "Available",
    "unavailable": "Unavailable",
    "toggleAria": "Toggle my availability",
    "tooltip": "Toggle whether you receive new ticket assignments",
    "nowAvailable": "You are now available for new tickets.",
    "nowUnavailable": "You are now unavailable — new tickets will skip you.",
    "toggleFailed": "Could not update your availability."
  },
  "channelType": {
    "webchat": "Web Chat",
    "email": "Email",
    "ai_bot": "AI Bot",
    "staff": "Staff",
    "facebook": "Facebook",
    "zalo": "Zalo",
    "telegram": "Telegram",
    "wechat": "WeChat",
    "facebook_personal": "Facebook (Personal)",
    "zalo_personal": "Zalo (Personal)",
    "lark": "Lark"
  },
  "channelStatus": {
    "connected": "Connected",
    "disconnected": "Disconnected",
    "error": "Error",
    "pending": "Pending"
  },
  "addChannel": {
    "title": "Add channel",
    "subtitle": "Connect a social platform to receive support messages.",
    "selectPlatform": "Select a platform",
    "platformLabel": "Platform",
    "nameLabel": "Display name",
    "namePlaceholder": "e.g. Printway Support Page",
    "next": "Next",
    "back": "Back",
    "cancel": "Cancel",
    "connect": "Connect",
    "connecting": "Connecting…",
    "verify": "Verify connection",
    "verifying": "Verifying…",
    "verified": "Connection verified.",
    "verifyFailed": "Could not verify the connection. Check the credentials and try again.",
    "wechatComingSoon": "WeChat integration is coming soon and cannot be connected yet.",
    "created": "Channel connected.",
    "createFailed": "Could not connect the channel.",
    "steps": {
      "facebook": "Grant the Printway app access to your Facebook Page, then paste the Page access token below.",
      "zalo": "Authorize the Printway Official Account app, then provide your Zalo OA id and app credentials.",
      "telegram": "Create a bot with @BotFather and paste the bot token below.",
      "lark": "Create an internal app in the Lark Developer Console, enable the bot, then paste the App ID, App Secret and Event Subscription verification token. After connecting, set the event subscription URL to <api>/api/v1/support/webhooks/lark and subscribe to im.message.receive_v1."
    },
    "fields": {
      "pageId": "Page ID",
      "pageToken": "Page access token",
      "oaId": "Official Account ID",
      "appId": "App ID",
      "appSecret": "App secret",
      "botToken": "Bot token",
      "botUsername": "Bot username",
      "accessToken": "Access token",
      "refreshToken": "Refresh token",
      "verificationToken": "Verification token"
    }
  },
  "reply": {
    "windowClosed": "Reply window closed",
    "windowClosedHint": "The 24-hour messaging window has expired. The customer must message again before you can reply.",
    "resend": "Resend",
    "resending": "Resending…",
    "resent": "Message resent.",
    "resendFailed": "Could not resend the message."
  },
  "deliveryStatus": {
    "queued": "Queued",
    "sending": "Sending",
    "sent": "Sent",
    "delivered": "Delivered",
    "read": "Read",
    "failed": "Failed",
    "undelivered": "Undelivered",
    "pending": "Pending",
    "blocked_window": "Window closed"
  },
  "linkRequester": {
    "title": "Link requester to a merchant",
    "subtitle": "Match this social contact with a merchant account.",
    "searchPlaceholder": "Search by name or email…",
    "loading": "Searching…",
    "noMatch": "No merchant matched \"{{query}}\".",
    "link": "Link",
    "linking": "Linking…",
    "linked": "Requester linked.",
    "linkFailed": "Could not link the requester.",
    "unlink": "Unlink",
    "unlinked": "Requester unlinked.",
    "currentlyLinked": "Linked to {{name}}",
    "searchHint": "Type at least 2 characters to search users and merchants.",
    "currentRequester": "Current requester",
    "externalUnknown": "Unknown sender",
    "platformUser": "Platform ID: {{id}}",
    "accountType": {
      "user": "User",
      "merchant": "Merchant"
    },
    "confirmTitle": "Confirm link",
    "confirmPrompt": "Link {{platform}} sender {{external}} to {{account}}?",
    "replaceWarning": "This replaces the currently linked account ({{name}}).",
    "confirm": "Confirm link",
    "cancel": "Cancel",
    "back": "Back",
    "retry": "Retry",
    "searchError": "Could not search accounts. Please try again."
  },
  "channelActions": {
    "empty": "No channels connected yet. Add one to start receiving messages.",
    "loadFailed": "Could not load channels.",
    "reconnect": "Reconnect",
    "disconnect": "Disconnect",
    "disconnected": "Channel disconnected.",
    "disconnectFailed": "Could not disconnect the channel.",
    "deleteConfirm": "Remove this channel? Existing conversations are kept but no new messages will arrive.",
    "deleted": "Channel removed.",
    "deleteFailed": "Could not remove the channel.",
    "verifyConnection": "Verify connection"
  },
  "socialThread": {
    "loadOlder": "Load older messages",
    "loadingOlder": "Loading…",
    "empty": "No messages in this conversation yet.",
    "loadError": "Could not load the conversation.",
    "linkRequester": "Link requester",
    "attachmentDownload": "Download attachment",
    "composerPlaceholder": "Type your reply…",
    "composerSend": "Send",
    "composerSending": "Sending…",
    "composerAttach": "Attach file",
    "composerAttachRemove": "Remove attachment",
    "composerNotSupported": "Replies are not supported for this channel yet.",
    "composerSent": "Reply sent.",
    "composerSendFailed": "Could not send the reply.",
    "deliveryErrorCode": "Error code: {{code}}",
    "deviceOffline": "The bridge device is offline — messages will queue until it reconnects.",
    "deviceRevoked": "This bridge device was revoked — pair a new device to resume."
  },
  "dispatch": {
    "title": "Dispatch to vendor / department",
    "target": {
      "vendor": "Vendor",
      "department": "Internal department"
    },
    "department": {
      "Finance": "Finance",
      "IT": "IT",
      "Logistics": "Logistics",
      "Product": "Product"
    },
    "status": {
      "Dispatched": "Dispatched",
      "InProgress": "In progress",
      "Returned": "Returned",
      "Cancelled": "Cancelled"
    },
    "pickVendor": "Select a vendor",
    "scopeNotePlaceholder": "Describe the task for the handler (no merchant PII for vendors)",
    "replyPlaceholder": "Reply in this dispatch thread…",
    "submit": "Dispatch",
    "cancel": "Cancel",
    "send": "Send",
    "return": "Return to support",
    "recall": "Recall",
    "empty": "No dispatches",
    "navTitle": "Dispatch queue",
    "toast": {
      "created": "Dispatch created",
      "error": "Action failed"
    },
    "titleVendor": "Push to Vendor",
    "titleDepartment": "Push to Department",
    "scopeNoteLabel": "Scope note"
  },
  "compose": {
    "keyboardHint": "Enter to send · Option+Enter for a new line · Paste images with Ctrl+V",
    "attach": "Attach file",
    "uploading": "Uploading…",
    "removeAttachment": "Remove {{filename}}",
    "linkOrder": "Link order",
    "searchOrder": "Search order…",
    "noOrders": "No orders found",
    "uploadFailTitle": "Could not upload file",
    "fileTooLarge": "File exceeds the 10MB limit",
    "fileTypeForbidden": "This file type is not allowed",
    "download": "Download",
    "imageAlt": "Attached image",
    "attachDisabledHint": "Attachments are only available while the dispatch is active"
  },
  "stats": {
    "all": "All tickets",
    "open": "Open",
    "inProgress": "In progress",
    "awaitingHandler": "Awaiting handler",
    "pendingSupportReview": "Pending review",
    "resolved": "Resolved"
  },
  "quick": {
    "heading": "Quick actions",
    "trackOrder": {
      "label": "Track Order",
      "caption": "Check the status or location of an order.",
      "subject": "Track my order",
      "description": "I'd like to check the current status and location of my order. Order number: "
    },
    "startReturn": {
      "label": "Start Return",
      "caption": "Request a return or refund for an order.",
      "subject": "Start a return",
      "description": "I'd like to start a return or refund for my order. Order number: \nReason: "
    },
    "orderIssues": {
      "label": "Order Issues",
      "caption": "Report a problem with a product or delivery.",
      "subject": "Issue with my order",
      "description": "I'm having an issue with a product in my order. Order number: \nWhat went wrong: "
    },
    "paymentHelp": {
      "label": "Payment Help",
      "caption": "Get help with billing or payments.",
      "subject": "Payment / billing help",
      "description": "I need help with a payment or billing matter. Please describe your question: "
    }
  },
  "bridgeDeviceStatus": {
    "online": "Online",
    "offline": "Offline",
    "revoked": "Revoked"
  },
  "bugCategoryLabels": {
    "UI": "UI",
    "Logic": "Logic",
    "Performance": "Performance",
    "Data": "Data",
    "Security": "Security"
  }
}
